import { Box, Avatar, Typography } from '@mui/material'
import { useHistory } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { userButtonList } from '../../../components/utils/buttonList'
import CustomerAdminUserActionBtn from './CustomerAdminUserActionBtn.jsx'
import { getFirstAndSecondCharacterOnly } from '../../../utils/helpers'
import UseTranslation from '../../../hooks/UseTranslation.jsx'
import HoverTooltip from '../../../components/PageHelpers/HoverTooltip.jsx'
import { customerAdminSelectUsers } from '../../../redux/features/users/customerAdmin/customerAdminSlice'
import CardWithSpace from '../../../components/Cards/CardWithSpace/index.jsx'
import LoadMoreBtn from '../../../components/PageHelpers/LoadMoreBtn.jsx'
import { retrieveCustomerAdminUsers } from '../../../redux/features/users/customerAdmin/customerAdminThunk'

const CustomerAdminUsersCard = () => {
  const customerAdminUsers = useSelector(customerAdminSelectUsers)
  const baseUri = process.env.REACT_APP_ROOT_ROUTE || ''
  const history = useHistory()
  const { t } = UseTranslation()
  const getUserStatus = (user) => (user?.active ? userButtonList[0] : userButtonList[1])
  const userProfileHandler = (user) => {
    history.push(`${baseUri}/user/${user.id}`)
  }
  return (
      <Box sx={styles.container}>
      {customerAdminUsers?.data?.map((user) => (
        <CardWithSpace key={user?.id} customStyle={styles.cardWithSpace}>
    <Box sx={[styles.singleCard]}>
      <Box sx={styles.info} onClick={() => userProfileHandler(user)}>
        <Box>
       <Avatar sx={styles.avatar}>
        {getFirstAndSecondCharacterOnly(user?.name)}
       </Avatar>
        </Box>
        <Box sx={styles.infoContainer}>
        <Box sx={styles.nameUnit}>
            <Typography component={'span'}>{`${t?.['User Name']}`}</Typography>
            <HoverTooltip title={user?.name || `${t?.['No User Name']}`}>
            <Typography variant='body1'>
          { user?.name || `${t?.['No User Name']}`}
            </Typography>
            </HoverTooltip>
        </Box>
        <Box sx={styles.infoUnit}>
            <Typography component={'span'}>{`${t?.email}`}</Typography>
            <HoverTooltip title={user?.email}>
            <Typography variant='body1'>
            {user?.email}
         </Typography>
            </HoverTooltip>
        </Box>
        <Box sx={styles.infoUnit}>
            <Typography component={'span'}>{`${t?.['User Type']}`}</Typography>
            <HoverTooltip title={user?.user_types}>
            <Typography variant='body1'>
          {user?.user_types}
            </Typography>
            </HoverTooltip>
        </Box>
        <Box sx={styles.infoUnit}>
            <span>{`${t?.Status}`}</span>
            <HoverTooltip title={t?.[getUserStatus(user)?.title]}>
            <Box sx={{ color: getUserStatus(user)?.color }}>{t?.[getUserStatus(user)?.title]}</Box>
            </HoverTooltip>
        </Box>
        </Box>
      </Box>
      <CustomerAdminUserActionBtn user={user} customStyle={styles.actionBtn} />
        </Box>
             </CardWithSpace>
      ))}
         <LoadMoreBtn
        store={customerAdminUsers}
        actionToDispatch={retrieveCustomerAdminUsers}
        sendQueryAsObject />
      </Box>
  )
}

const styles = {
  container: {
    width: '100%',
  },
  singleCard: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    fontSize: { xs: '14px', md: '16px' },
    padding: { xs: '10px 20px 10px 10px', md: '0px 20px' },
    margin: { xs: '10px', md: '10px 0' },
    borderRadius: '12px',
    position: { xs: 'relative', md: 'unset' },
    height: { xs: 'unset', md: '110px' },
  },
  info: {
    display: 'flex',
    flexDirection: { xs: 'row', md: 'row' },
    justifyContent: 'space-between',
    alignItems: { xs: 'center', md: 'center' },
    width: { xs: '90%', md: '100%' },
    cursor: 'pointer',
  },
  avatar: {
    display: 'flex',
    bgcolor: '#FFC542',
    color: 'white',
    height: { xs: '50px', md: '64px' },
    width: { xs: '50px', md: '64px' },
    mr: { xs: '0px', md: '29px' },
    textTransform: 'uppercase',
    fontWeight: 800,
    fontSize: { xs: '16px', md: '25px' },
  },
  infoContainer: {
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    width: '100%',
    marginLeft: { xs: '10px', md: '0px' },
  },
  nameUnit: {
    display: 'flex',
    flexDirection: { xs: 'row', md: 'column' },
    justifyContent: { xs: 'flex-start', md: 'center' },
    maxWidth: { xs: '90%', sm: '180px' },
    width: '100%',
    alignItems: 'flex-start',
    '& p': {
      fontSize: { xs: '12px', md: '16px' },
      whiteSpace: { xs: 'unset', md: 'nowrap' },
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      width: 'fit-content',
      maxWidth: { xs: '90%', md: '95%' },
      fontWeight: { xs: '600', md: '500' },
    },
    '& span': {
      display: { xs: 'none', md: 'block' },
      width: 'fit-content',
      fontSize: { xs: '12px', md: '14px' },
      opacity: '0.7',
      fontWeight: '500',
      color: 'text.hint',
      marginBottom: '10px',
      marginRight: { xs: '10px', md: '0px' },
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
  },
  infoUnit: {
    display: 'flex',
    flexDirection: { xs: 'row', md: 'column' },
    justifyContent: { xs: 'flex-start', md: 'center' },
    maxWidth: { xs: '90%', sm: '180px' },
    width: '100%',
    alignItems: 'flex-start',
    '& p': {
      fontSize: { xs: '12px', md: '16px' },
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      width: 'fit-content',
      maxWidth: { xs: '100%', md: '95%' },
      marginBottom: { xs: '5px', md: '0px' },
    },
    '& span': {
      display: { xs: 'none', md: 'block' },
      width: '85%',
      fontSize: { xs: '12px', md: '14px' },
      opacity: '0.7',
      fontWeight: '500',
      color: 'text.hint',
      marginBottom: '10px',
      marginRight: { xs: '10px', md: '0px' },
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
  },
  actionBtn: {
    position: { xs: 'absolute', md: 'unset' },
    top: { xs: '10px', md: 'unset' },
    right: { xs: '10px', md: 'unset' },
  },
}
export default CustomerAdminUsersCard
